export const ERROR_UPDATE_REQUEST = 'ERROR_UPDATE_REQUEST';
export const ERROR_UPDATE_SUCCESS = 'ERROR_UPDATE_SUCCESS';

export const ERROR_RESET_REQUEST = 'ERROR_RESET_REQUEST';
export const ERROR_RESET_SUCCESS = 'ERROR_RESET_SUCCESS';

export const VALIDATION_ERROR_REQUEST = 'VALIDATION_ERROR_REQUEST';
export const VALIDATION_ERROR_SUCCESS = 'VALIDATION_ERROR_SUCCESS';

export const ERROR_PASS_REQUEST = 'ERROR_PASS_REQUEST';
